import { Component, Input, OnInit } from "@angular/core";
import * as L from 'leaflet';
import * as $ from 'jquery';
import 'leaflet.markercluster';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import { GeoLocationService } from "../../../../shared/services/geo-location.service";
import { ExploreService } from "../../services/explore.service";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../../../../environments/environment";
import { ToastrService } from "ngx-toastr";
import AppShareHelper from "../../../../shared/utils/helper";
import { AppService } from "../../../../core/services/app.service";
import { HttpClient } from "@angular/common/http";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ViewExplorePhotoComponent } from "../view-explore-photo/view-explore-photo.component";
import { PermissionAdminService } from "../../../../shared/services/guard-services/permission-admin.service";
import { CamerallaAuthService } from "../../../../shared/services/authentication-services/cameralla-auth.service";
import { UserService } from "../../../user/services/user.service";
import { LocationService } from "../../../../shared/services/location.service";
import { LanguageConstant } from "../../../../shared/constants/language-constant";

@Component({
    selector: 'app-explore-page',
    templateUrl: './explore-page.component.html',
    providers: [GeoLocationService]
})

export class ExplorePageComponent implements OnInit {
    address;
    marker;
    geoTagPhotos: any = [];
    showCircle: boolean = false;
    showGoldenPhoto: boolean = false;
    circle;
    checkPoint;
    position: any
    @Input('groupId') groupId: number = null;
    @Input('groupDetail') groupDetail: any= {};
    haveLocation: boolean = true;
    ownerLocationFeature = false;
    // Default location of Norway
    defaultLat = 60.5000209;
    defaultLng = 9.0999715;
    partners = []
    defaultPartners = [
        {
            "name": "Explorer",
            "iconPartnerUrl": "https://camerallaphoto.com/wp-content/uploads/2021/06/icon-golden-photo.png",
            "id": 1
        },
        {
            "name": "Canon",
            "iconPartnerUrl": "https://camerallaphoto.com/wp-content/uploads/2021/06/icon-golden-photo.png",
            "id": 2
        },
        {
            "name": "Hurtigruten",
            "iconPartnerUrl": "https://camerallaphoto.com/wp-content/uploads/2021/06/icon-hurtigruten.png",
            "id": 4
        },
        {
            "name": "Kampsport",
            "iconPartnerUrl": "https://camerallaphoto.com/wp-content/uploads/2021/06/icon-golden-photo.png",
            "id": 5
        },
        {
            "name": "NAF",
            "iconPartnerUrl": "https://camerallaphoto.com/wp-content/uploads/2021/06/icon-golden-photo.png",
            "id": 6
        }
    ];
    selectedPartner;
    mapIcon = null;
    public map;
    rewardIcon = L.icon({
        iconUrl: require('./../../../../../assets/images/red-location.png'),
        iconSize: [30, 30], // size of the icon
        popupAnchor: [0, -15] // point from which the popup should open relative to the iconAnchor
    });

    goldenCameraIcon = null;
    localUserId;
    isAdmin = false;
    loaded = false;
    userPreferredLanguage = null;

    constructor(private geoLocationService: GeoLocationService,
                protected router: Router,
                protected toastr: ToastrService,
                protected http: HttpClient,
                protected locationService: LocationService,
                protected exploreService: ExploreService,
                protected camerallaAuthService: CamerallaAuthService,
                protected route: ActivatedRoute,
                protected userService: UserService,
                protected _modalService: NgbModal) {
    }

    ngOnInit() {
        this.ownerLocationFeature = (this.groupDetail && this.groupDetail.metaData && this.groupDetail.metaData.ownerLocationFeature) || false;
        this.localUserId = +this.camerallaAuthService.getLocalUserInfo()['id'];
        this.mapIcon = this.groupId ? 'blue-location.png' : 'golden-location.png';
        this.goldenCameraIcon = L.icon({
            iconUrl: this.groupId ? require('./../../../../../assets/images/blue-location.png') : require('./../../../../../assets/images/golden-location.png'),
            iconSize: [30, 30], // size of the icon
            popupAnchor: [0, -15] // point from which the popup should open relative to the iconAnchor
        })
        
        this.userService.getPersonalDetails(this.localUserId).then(
          (data) => {
              this.isAdmin = !!(data.role == PermissionAdminService.adminConst);
              this.userPreferredLanguage = data.preferredLanguage ? data.preferredLanguage : LanguageConstant.NO;
              this.loaded = true;
              if (this.route.snapshot.queryParamMap.get('locationId')) {
                  this.locationService.getLocationDetail(this.route.snapshot.queryParamMap.get('locationId')).subscribe((location: any) => {
                      const modalRef = this._modalService.open(ViewExplorePhotoComponent, {centered: true,  windowClass: "image-card-popup"});
                      modalRef.componentInstance.locationDetail = location.Data;
                      modalRef.componentInstance.isAdmin = this.isAdmin;
                      modalRef.componentInstance.groupId = this.groupId;
                  })
              }
              this.setCurrentLocation();
          });
    }

    public initMap(lat, lng) {
        // refresh map id
        if (lat && lng) {
            this.map = L.map("map", {
                center: [lat, lng],
                // Set the initial zoom level, values 0-18, where 0 is most zoomed-out (required)
                zoom: 5,
                preferCanvas: true
            });

            this.addCurrentMarker(lat, lng);
            this.createTitleLayer();
            this.addSearchControl();
            this.addNearByMeControl();
            //this.addGoldenPhotoControl();
            this.getGeoTagPhotos();

            //handle click event
            this.map.on('dblclick', e => {
                const coord = e.latlng;
                if (coord && !this.showCircle) {
                    this.addCurrentMarker(coord.lat, coord.lng);
                }
            });
        }

    }

    addMarker(lat, lng, photo, reward = false) {
        const customPopup = `<div class="card" id="navigatePhoto">
            <a target="_blank" rel="noopener noreferrer" href="${photo.photoDetailLink}"><img class="card-img-top" src="${photo.thumbnail}" alt="Card image cap"></a>
            <div class="card-body p-1">
<!--              <h5 class="card-title">${photo.location}</h5>-->
<!--              <p class="card-text">This card has supporting text below as a natural lead-in to additional content.</p>-->
<!--              <p class="card-text"><small class="text-muted">${photo.location}</small></p>-->
              <p class="card-text m-0"><small class="text-muted">${photo.location}</small></p>
            </div>
          </div>
        `;
        // popover
        if (lat && lng) {
            this.marker = L.marker([lat, lng], {icon: (photo.partnerId == 99 || reward) ? this.rewardIcon : this.goldenCameraIcon, zIndexOffset : 1000})
                  .on('click', (e)=> {
                      const modalRef = this._modalService.open(ViewExplorePhotoComponent, {centered: true,  windowClass: "image-card-popup"});
                      modalRef.componentInstance.locationDetail = photo;
                      modalRef.componentInstance.isAdmin = this.isAdmin;
                      modalRef.componentInstance.groupId = this.groupId;
                  })
                .addTo(this.map);
        }
    }

    addCurrentMarker(lat, lng) {
        if (this.checkPoint) {
            this.map.removeLayer(this.checkPoint);
        }

        this.checkPoint = L.marker([lat, lng], {isMarker: true}).addTo(this.map);
    }

    createTitleLayer() {
        // Create a Tile Layer and add it to the map
        L.tileLayer('http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',{
            maxZoom: 20,
            subdomains:['mt0','mt1','mt2','mt3']
        }).addTo(this.map);
    
        // L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        //     attribution: '&copy; <a href="http://osm.org/copyright"></a> contributors',
        //     // Local access tokens key
        //     // accessToken: 'pk.eyJ1IjoibWljaGVsbmd1eWVuIiwiYSI6ImNraHYxbzVucjEzNW8yeHBpdjJldGhpaHcifQ.rsmZChq3K2bHG2gx3gG5pg'
        //     // Live access tokens key
        //     accessToken: 'pk.eyJ1IjoibWljaGVsbmd1eWVuIiwiYSI6ImNrZ2h1ZXVocjA5d2gyeW8wOGQxOGlqamUifQ.2Inx1nlM0hOWVGmSnwNFMg'
        // }).addTo(this.map);
    }

    addSearchControl() {
        // add search control https://github.com/smeijer/leaflet-geosearch
        const provider = new OpenStreetMapProvider();
        const searchControl = new GeoSearchControl({
            provider: provider,
            autoClose: true
        });
        this.map.addControl(searchControl);

        // handler
        this.map.on("geosearch/showlocation", e => {
            if (e.location.x && e.location.y) {
                this.addCurrentMarker(e.location.y, e.location.x);
            }
        });
    }

    addNearByMeControl() {
        const me = this;
        const photoNearByMeControl = L.Control.extend({
            options: {
                position: 'topleft',
            },
            onAdd: function (map) {
                const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom-near-me');

                container.style.backgroundColor = 'white';
                container.style.backgroundImage = "url('./../../../../../club/assets/images/icon-near-me.png')";
                container.style.backgroundSize = "26px 26px";
                container.style.width = '26px';
                container.style.height = '26px';
                container.title = 'Photo nearby me';

                container.onclick = function () {
                    container.style.backgroundColor = me.showCircle ? 'white' : '#ffa300';
                    if (me.haveLocation) {
                        me.changeStyleControl('.leaflet-control-gps');
                        me.changeStyleControl('.leaflet-bar-part-single');
                    }
                    me.setCurrentLocation(true);
                }
                return container;
            }
        });
        if (this.haveLocation) {
            const gpsControl = L.Control.extend({
                options: {
                    position: 'topleft',
                },
                onAdd: function (map) {
                    const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-gps');

                    container.style.backgroundColor = 'white';
                    container.style.backgroundRepeat = 'no-repeat';
                    container.style.backgroundPosition = 'center';
                    container.style.backgroundImage = "url('./../../../../../club/assets/images/gps.png')";
                    container.style.backgroundSize = "20px 20px";
                    container.style.width = '26px';
                    container.style.height = '26px';
                    container.title = 'GPS';

                    container.onclick = function () {
                        container.style.backgroundColor = me.showCircle ? 'white' : '#ffa300';
                        me.changeStyleControl('.leaflet-control-custom-near-me');
                        me.setCurrentLocation(true, true);
                    }
                    return container;
                }
            });
            this.map.addControl(new gpsControl());
        }
        this.map.addControl(new photoNearByMeControl());
    }

    addGoldenPhotoControl() {
        const me = this;
        const goldenPhotoControl = L.Control.extend({
            options: {
                position: 'topleft',
            },
            onAdd: function (map) {
                const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-golden');
                let partnersHTML = '';

                me.getPartners().subscribe(
                (res: any) => {
                    me.partners = (res.Data && res.Data.length > 0) ? res.Data : me.defaultPartners;

                    if (me.partners && me.partners.length > 0) {
                        me.partners.forEach(item => {
                            if (item.iconPartnerUrl && item.id != 1) {
                                partnersHTML += `<div id="${item.id}" class="d-flex mb-2 p-1 dropdown-item cursor-pointer">
                                        <img class="mr-3" src="${item.iconPartnerUrl}" width="24" height="24" alt="">
                                        <span class="cursor-pointer text-center">${item.id === 1 ? 'Golden photo' : item.name}</span>
                                    </div>`;
                            }
                        });
                        container.innerHTML = `
                                <div class="dropdown-menu dropdown-menu-left p-1 shadow triangle-up-border">
                                    <p class="text-center font-family-medium mx-2 my-3 text-warning">Select partner</p>
                                    <hr>
                                    ${partnersHTML}
                                    <div id="reset" class="mb-2 p-1 dropdown-item">
                                        <span class="cursor-pointer text-warning">Reset</span>
                                    </div>
                                </div>`;

                    }
                    
                    container.setAttribute('data-toggle', 'dropdown');
                    container.style.backgroundColor = 'white';
                    container.style.backgroundRepeat = 'no-repeat';
                    container.style.backgroundPosition = 'center';
                    container.style.backgroundImage = `url('./../../../../../club/assets/images/${me.mapIcon}')`;
                    container.style.backgroundSize = "20px 20px";
                    container.style.width = '26px';
                    container.style.height = '26px';
                    container.title = 'Golden photo';

                    $(".dropdown-menu").on("click", "div", function(event){
                        me.selectPartner(event.currentTarget.id, container);
                        container.style.backgroundColor = !me.showGoldenPhoto ? 'white' : '#ffa300';
                    })
                })
                return container;
            }
        });
        this.map.addControl(new goldenPhotoControl());
    }

    changeStyleControl(className) {
        let ctr = <HTMLElement>document.querySelector(className);
        ctr.style.backgroundColor = (this.showCircle || !this.showGoldenPhoto) ? 'white' : 'gainsboro';
        ctr.style.opacity = (this.showCircle || !this.showGoldenPhoto) ? '1' : '0.6';
        ctr.style.pointerEvents = (this.showCircle || !this.showGoldenPhoto) ? 'auto' : 'none';
    }

    flyToPoint(lat, lng) {
        this.map.flyTo([lat, lng], 8)
        this.setCircleLocation(lat, lng);
    }

    setCurrentLocation(flag?, forceShowCurrent?) {
        if (this.checkPoint && !forceShowCurrent) {
            this.flyToPoint(this.checkPoint._latlng.lat, this.checkPoint._latlng.lng);
        } else {
            this.geoLocationService.getLocation().subscribe((position) => {
                if (position && position.coords && position.coords.latitude && position.coords.longitude) {
                    if (flag) {
                        this.addCurrentMarker(position.coords.latitude, position.coords.longitude)
                        this.flyToPoint(position.coords.latitude, position.coords.longitude);
                    } else {
                        this.initMap(position.coords.latitude, position.coords.longitude)
                    }
                } else {
                    this.haveLocation = false;
                    this.toastr.warning(position);
                    this.initMap(this.defaultLat, this.defaultLng);
                }
            })
        }
    }
    
    private skip;
    private limit;
    getGeoTagPhotos(showGlodenPhoto?) {
        this.skip = 0;
        this.limit = 1200;
        if (showGlodenPhoto && this.geoTagPhotos.length > 0) {
            let result = [];

            result = this.geoTagPhotos.filter(item => (item.isGolden != 0) && (this.selectedPartner
                && (item.isGolden == this.selectedPartner.id)));
            this.showPhotoInMap(result, false, true);
        } else {
            this.showMarkerData(this.skip);
        }
    }
    
    showMarkerData(skip) {
        let groupParams = null;
        if (this.groupId) {
            groupParams = {
                id : this.groupId,
                ownerId : this.groupDetail.owner,
                userId: this.localUserId,
                ownerLocationFeature: this.ownerLocationFeature
            }
        }
        
        this.locationService.getLocationList(this.groupId ? 0 : 1, null, this.skip, this.limit, groupParams).subscribe((res: any) => {
            if (res.IsSuccess && res.Data) {
                if (res.Data.length > 0) {
                    this.geoTagPhotos = res.Data;
                    this.showPhotoInMap(res.Data);
                    if (res.Data.length === this.limit) {
                        this.skip = this.skip + this.limit;
                        this.showMarkerData(this.skip);
                    }
                }
            }
        })
    }

    showPhotoInMap(data?, showAllMarker?, isGolden?) {
        if (showAllMarker) {
            this.map.eachLayer(layer => {
                if ((layer.options.icon || layer.options.isFeatureMarker) && !layer.options.isMarker) {
                    this.map.removeLayer(layer);
                }
            });
        }

        const selectedPartner = this.selectedPartner;
        const me = this;
        var mcg = L.markerClusterGroup({
            iconCreateFunction: function (cluster) {
                const markers = cluster.getAllChildMarkers();
                const html = `<div class="circle"
                        style="background-image: url(${(selectedPartner && selectedPartner.iconPartnerUrl) ? selectedPartner.iconPartnerUrl : ('assets/images/' + me.mapIcon) })">
                        <span class="badge badge-pill badge-primary" style="float:right;margin-bottom:-10px;">${markers.length}</span></div>`;
                return L.divIcon({html: html, className: 'mycluster', iconSize: L.point(35, 35)});
            },
            spiderfyOnMaxZoom: false,
            showCoverageOnHover: false,
            zoomToBoundsOnClick: true,
            isFeatureMarker: true
        });

        const photos = data || this.geoTagPhotos;
        photos.filter(item => {
            if (AppShareHelper.checkLatLngLocation(item)) {
                item.photoDetailLink = environment['site'] + 'club/photo/' + item.id;
                let groupOwnerMarker = false;
                if (this.groupId) {
                    if (this.ownerLocationFeature) {
                        if (item.customerId == this.groupDetail.owner) {
                            groupOwnerMarker = this.rewardIcon;
                        }
                    }
                }
                
                if (showAllMarker || item.partnerId == 99 || groupOwnerMarker) {
                    this.addMarker(item.lat, item.lng, item, groupOwnerMarker);
                } else {
                    // Add marker
                    const customPopup = `<div class="card" id="navigatePhoto">
                    <a target="_blank" rel="noopener noreferrer" href="${item.photoDetailLink}"><img class="card-img-top" src="${item.thumbnail}" alt="Card image cap"></a>
                    <div class="card-body p-1">
                      <p class="card-text m-0"><small class="text-muted">${item.location}</small></p>
                    </div>
                  </div>`;
                    
                    this.marker = L.marker(new L.LatLng(item.lat, item.lng), {icon: this.goldenCameraIcon, photoData: item})
                      .on('click', (e)=> {
                          const modalRef = this._modalService.open(ViewExplorePhotoComponent, {centered: true,  windowClass: "image-card-popup"});
                          modalRef.componentInstance.locationDetail = item
                          modalRef.componentInstance.isAdmin = this.isAdmin;
                          modalRef.componentInstance.groupId = this.groupId;
                      });
                    mcg.addLayer(this.marker);
                }
            }
        });
        mcg.on('clusterclick', (e) => {
            if (e.target._zoom >= 18) {
                const array = e.layer.getAllChildMarkers();
                if (array.length > 0 && !e.layer.getPopup()) {
                    const modalRef = this._modalService.open(ViewExplorePhotoComponent, {centered: true,  windowClass: "image-card-popup"});
                    modalRef.componentInstance.locationDetailArr = array;
                    modalRef.componentInstance.isAdmin = this.isAdmin;
                    modalRef.componentInstance.groupId = this.groupId;
                    
                }
            }
        });

        if (!showAllMarker) {
            this.map.addLayer(mcg);
        }
    }

    getImageInsideCircle(circle, point) {
        const radius = circle.getRadius(); //in meters
        const circleCenterPoint = circle.getLatLng(); //gets the circle's center latlng
        return Math.abs(circleCenterPoint.distanceTo(point)) <= radius;
    }

    setCircleLocation(lat, lng) {
        if (this.circle) {
            this.map.removeLayer(this.circle);
            if (this.showCircle) {
                this.map.eachLayer(layer => {
                    if (layer.options.icon && !layer.options.isMarker) {
                        if (this.getImageInsideCircle(this.circle, layer._latlng)) {
                            this.map.removeLayer(layer);
                        }
                    }
                });
            }
        }

        // Remove all feature marker when set circle location
        this.showPhotoInMap(null, !this.showCircle);

        if (!this.showCircle) {
            if (lat && lng) {
                this.circle = L.circle([lat, lng], {
                    fillOpacity: 0.2,
                    radius: 40000
                }).addTo(this.map);

                if (!this.checkPoint) {
                    this.checkPoint = L.marker([lat, lng], {isMarker: true}).addTo(this.map);
                }

                this.map.eachLayer(layer => {
                    if (layer.options.icon) {
                        if (!this.getImageInsideCircle(this.circle, layer._latlng)) {
                            this.map.removeLayer(layer);
                        }
                    }
                });
            }
        }

        this.showCircle = !this.showCircle;
    }

    getPartners() {
        return this.http.get(AppService.getApiUrl() + '/api/partners');
    }

    selectPartner(id, container?) {
        this.selectedPartner = this.partners.find(item => {
           // return (this.selectedPartner && this.selectedPartner.id && (this.selectedPartner.id == id)) ? null : (item.id == id);
           return (item.id == id);
        });

        if (this.selectedPartner && this.selectedPartner.iconPartnerUrl) {
            this.goldenCameraIcon = L.icon({
                iconUrl: this.selectedPartner.iconPartnerUrl,
                iconSize: [30, 30], // size of the icon
                popupAnchor: [0, -15] // point from which the popup should open relative to the iconAnchor
            });
        }

        // Change icon in golden photo button
        if (container) {
            container.style.backgroundImage = `url(' ${(this.selectedPartner && this.selectedPartner.iconPartnerUrl) ? this.selectedPartner.iconPartnerUrl : './../../../../../club/assets/images/' + this.mapIcon}')`;
        }

        this.showGoldenPhoto = (id != 'reset');

        if (this.haveLocation) {
            this.changeStyleControl('.leaflet-control-gps');
            this.changeStyleControl('.leaflet-bar-part-single');
        }
        this.changeStyleControl('.leaflet-control-custom-near-me');

        // Clear all camera icon
        this.map.eachLayer(layer => {
            if ((layer.options.icon || layer.options.isFeatureMarker) && !layer.options.isMarker) {
                this.map.removeLayer(layer);
            }
        });

        this.getGeoTagPhotos(this.showGoldenPhoto);
    }
}
